/* Global imports. */
import React from "react";

/* Component imports. */
import Layout from "@components/Layout";
import SEO from "@components/SEO";
import ImageKit from "@src/components/ImageKit";

const Template = () => (
  <Layout>
    <main className="container-main mt-14">
      <section>
        <div className="flex grid justify-center grid-cols-12">
          <div className="flex justify-center col-span-8 col-start-3 mb-8">
            <img src={ImageKit({image: "general/404.gif"})} alt="" />
          </div>
          <div className="w-full col-span-12 text-center">
            <h5 className="mb-8 font-sans text-3xl font-bold">
              “Oh, you can’t help that,” said the cat. “We’re all mad here.”
            </h5>
            <p>
              Maybe something moved, or you mistyped. But please do not worry. Try using search or{" "}
              <a href="mailto:webqueries@macmillan.co.uk?subject=Error%20report%20from%20404%20page">
                let us know
              </a>{" "}
              if you think you’ve spotted a problem.
            </p>
          </div>
        </div>
      </section>
    </main>
  </Layout>
);

export default Template;

export const Head = () => {
  return <SEO title="404: Not found" contentType="404" url="/page-not-found" />;
};
